import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Button, Header, Menu, Segment } from "semantic-ui-react";
import PartnerLogoComponent from "../../../../../Pages/Admin/PartnerLogoComponent";
import { headerNavigation as topNav, navigationIcons as navIco } from "../../../../Enums/NavigationEnums";
import styles from "./TaskModalHeader.module.css";

export interface TaskModalHeaderProps {
  hideAssessment: () => void;
  taskIndex: number;
  taskTitle: string | null;
  activeTab: string;
  menuNavigationEvent: (name: string) => void;
}

const TaskModalHeader: React.FC<TaskModalHeaderProps> = ({
  hideAssessment,
  taskTitle,
  activeTab,
  menuNavigationEvent,
}) => {
  const [displayTitle, setDisplayTitle] = useState('');
  useEffect(() => {
    updateTitle(activeTab);
  }, [taskTitle,activeTab]);

  const updateTitle= (name: any) => { 
    switch(name) {
      case topNav.TASKS:
        setDisplayTitle("");
        break;
      case topNav.LEARN:
        setDisplayTitle("Learn More About ");
        break;
      case topNav.RESOURCES:
        setDisplayTitle("Resources for ");
        break;
      case topNav.DOCUMENTS:
        setDisplayTitle("Documents for ");
        break;
    }
  }
  const updateNavigationEvent = (tab: string) => {
    menuNavigationEvent(tab);
  }  

  return (
    <>
      <Segment attached='top' id={styles.taskModalHeaderHeader}>
        <Menu fluid tabular className={styles.taskModalMenuHeader}  style={{padding: '0'}}  >
          <Menu.Menu className={styles.menuMenuLogo}>
            <Menu.Item className={styles.menuItemLogo}>
              <PartnerLogoComponent  />
            </Menu.Item>
          </Menu.Menu>
          <Menu.Menu position="right" className={styles.taskModalMenuMenuHeader}>
              <Menu.Item
                icon={navIco.TASKS}
                name={topNav.TASKS}
                role="menuTaskTab"
                className="hidden"
                onClick={() => updateNavigationEvent(topNav.TASKS)}
              />
              <Menu.Item
                icon={navIco.HELP}
                name={topNav.LEARN}
                role="menuTaskTab"
                className={activeTab === topNav.LEARN ? "selected" : ""}
                onClick={() => updateNavigationEvent(topNav.LEARN)}
              />
              <Menu.Item
                icon={navIco.RESOURCES}
                name={topNav.RESOURCES}
                role="menuTaskTab"
                className={activeTab === topNav.RESOURCES ? "selected" : ""}
                onClick={() => updateNavigationEvent(topNav.RESOURCES)}
              />
              <Menu.Item
                icon={navIco.DOCUMENTS}
                name={topNav.DOCUMENTS}
                role="menuTaskTab"
                className={activeTab === topNav.DOCUMENTS ? "selected" : ""}
                onClick={() => updateNavigationEvent(topNav.DOCUMENTS)}
              />
            </Menu.Menu>
            <Menu.Item  className={styles.taskModalMenuItemExitBtn}>
              <Button aria-label={topNav.EXIT} onClick={() => hideAssessment()} className={styles.taskModalExitBtn} > { topNav.EXIT }</Button>
            </Menu.Item>
          </Menu>  
          
        <Header className={styles.taskModalSubheaderModule} key={taskTitle} >
        { displayTitle } {taskTitle} 
        </Header>
      </Segment>
    </>
  );
};

export default observer(TaskModalHeader);
